// wrapper for the table
import React from 'react';

export const WorkspaceItemTableWrapper = ({
  children,
  ...rest
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className={'w-full relative'} style={{ marginTop: '20px' }} {...rest}>
      {children}
    </div>
  );
};
